import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import ReplyIcon from '@mui/icons-material/Reply';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

const EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🔥'];

export default function MessageActionSheet({ open, isOwn, onReact, onReply, onEdit, onDelete, onClose }) {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{
        sx: {
          backgroundColor: '#1a2a3a',
          borderRadius: '16px 16px 0 0',
          pb: 2,
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1, pb: 0.5 }}>
        <Box sx={{ width: 36, height: 4, borderRadius: 2, backgroundColor: 'rgba(255,255,255,0.2)' }} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-around', px: 2, py: 1.5 }}>
        {EMOJIS.map((emoji) => (
          <Box
            key={emoji}
            onClick={() => { onReact(emoji); onClose(); }}
            sx={{
              fontSize: '1.75rem',
              cursor: 'pointer',
              minWidth: 44,
              minHeight: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 2,
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' },
            }}
          >
            {emoji}
          </Box>
        ))}
      </Box>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />

      <List disablePadding>
        <ListItemButton onClick={() => { onReply(); onClose(); }} sx={{ py: 1.5, minHeight: 56 }}>
          <ListItemIcon sx={{ color: 'white', minWidth: 40 }}><ReplyIcon /></ListItemIcon>
          <ListItemText primary="Reply" primaryTypographyProps={{ color: 'white' }} />
        </ListItemButton>

        {isOwn && (
          <ListItemButton onClick={() => { onEdit(); onClose(); }} sx={{ py: 1.5, minHeight: 56 }}>
            <ListItemIcon sx={{ color: 'white', minWidth: 40 }}><EditIcon /></ListItemIcon>
            <ListItemText primary="Edit message" primaryTypographyProps={{ color: 'white' }} />
          </ListItemButton>
        )}

        {isOwn && (
          <ListItemButton onClick={() => { onDelete(); onClose(); }} sx={{ py: 1.5, minHeight: 56 }}>
            <ListItemIcon sx={{ color: '#ef4444', minWidth: 40 }}><DeleteOutlineIcon /></ListItemIcon>
            <ListItemText primary="Delete message" primaryTypographyProps={{ color: '#ef4444' }} />
          </ListItemButton>
        )}
      </List>
    </SwipeableDrawer>
  );
}
